import { apiClient } from "@/lib/api/client";
import { createFeedbackApi } from "@speakai/common/src/feedback/api";

export const { sendSuggestion } = createFeedbackApi(apiClient);
